import communityErrorService from './communityLoginError/communityErrorService';

angular.module('signalview.errorPages', []).service('communityErrorService', communityErrorService);
